module.exports = __webpack_public_path__ + "img/PC_07.1d924a68.jpg";